export default __webpack_public_path__ + "static/banner-f1a4af3824b7f23e20ace4a7cb3c91aa.jpg";